import { JSX } from "react";
import {
  EnvelopeIcon,
  MapPinIcon,
  PhoneIcon,
} from "@heroicons/react/24/outline";
import { motion, type Variants } from "framer-motion";

const styles = {
  section: "py-24 ",
  container: "container px-6 py-2 mx-auto",
  textCenter: "text-center",
  subtitle: "font-medium text-gray-500",
  title: "mt-2 text-2xl font-semibold text-gray-800 md:text-3xl",
  description: "mt-3 text-gray-500",
  grid: "grid grid-cols-1 gap-12 mt-10 lg:grid-cols-3",
  card: "flex flex-col items-center justify-center text-center",
  iconWrapper: "p-3 text-[#649dad] rounded-full bg-[#8bd4cb]/20",
  cardTitle: "mt-4 text-lg font-medium text-gray-800",
  cardText: "mt-2 text-gray-500",
  cardHighlight: "mt-2 text-[#649dad]",
};

const cardVariants: Variants = {
  hidden: { opacity: 0, y: 40, scale: 0.96 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { type: "spring" as const, stiffness: 80, damping: 14 },
  },
};

const ContactSection = (): JSX.Element => {
  return (
    <motion.div
      className={styles.section}
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ type: "spring", stiffness: 60, damping: 16 }}
      viewport={{ once: true, amount: 0.4 }}
    >
      <motion.div
        className={styles.container}
        initial={{ opacity: 0, scale: 0.97 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ type: "spring", stiffness: 80, delay: 0.1 }}
        viewport={{ once: true }}
      >
        <motion.div
          className={styles.textCenter}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          viewport={{ once: true }}
        >
          <motion.p className={styles.subtitle}>Contáctanos</motion.p>
          <motion.h2 className={styles.title}>Ponte en contacto</motion.h2>
          <motion.p className={styles.description}>
            Nuestro equipo siempre está dispuesto a ayudarte.
          </motion.p>
        </motion.div>

        <motion.div
          className={styles.grid}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          transition={{ staggerChildren: 0.18 }}
        >
          <motion.div
            className={styles.card}
            variants={cardVariants}
            whileHover={{
              scale: 1.04,
              transition: { type: "spring", stiffness: 200, damping: 15 },
            }}
          >
            <span className={styles.iconWrapper}>
              <EnvelopeIcon className="w-6 h-6" />
            </span>
            <h2 className={styles.cardTitle}>Correo Electrónico</h2>
            <p className={styles.cardText}>
              Nuestro equipo está aquí para ayudarte.
            </p>
            <p className={styles.cardHighlight}>contact@appcotas.com</p>
          </motion.div>

          <motion.div
            className={styles.card}
            variants={cardVariants}
            whileHover={{
              scale: 1.04,
              transition: { type: "spring", stiffness: 200, damping: 15 },
            }}
          >
            <span className={styles.iconWrapper}>
              <MapPinIcon className="w-6 h-6" />
            </span>
            <h2 className={styles.cardTitle}>Oficina</h2>
            <p className={styles.cardText}>
              Visítanos en nuestra oficina principal.
            </p>
            <p className={styles.cardHighlight}>
              Tucúman - Argentina
            </p>
          </motion.div>

          <motion.div
            className={styles.card}
            variants={cardVariants}
            whileHover={{
              scale: 1.04,
              transition: { type: "spring", stiffness: 200, damping: 15 },
            }}
          >
            <span className={styles.iconWrapper}>
              <PhoneIcon className="w-6 h-6" />
            </span>
            <h2 className={styles.cardTitle}>Teléfono</h2>
            <p className={styles.cardText}>Lun-Vie de 8:00 a 17:00.</p>
            <p className={styles.cardHighlight}>+54 (381) 479-3257</p>
          </motion.div>
        </motion.div>
      </motion.div>
    </motion.div>
  );
};
export default ContactSection;
